import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_14: DocMigration = {
  maxSchemaVersion: "0.0.14",
  apply(json: any) {
    if (!json.tables.palettes) {
      json.tables.palettes = {};
    }

    for (const elevationId in json.elevations) {
      const elevation = json.elevations[elevationId];
      delete elevation.exteriorPalettes;
      delete elevation.defaultExteriorPalette;

      if (elevation.settings) {
        delete elevation.settings;
      }

      if (typeof elevation.baseSettings === "object") {
        elevation.baseSettings = "Default";
      }

      const mtlSettingsId = elevation.settingsOverride?.exteriorMaterials;

      if (!mtlSettingsId) {
        const newSettingsId = uid();

        json.tables.settings[newSettingsId] = {
          type: "EXTERIOR_MATERIAL_SETTINGS",
          palettes: [elevation.baseSettings],
        };

        if (!elevation.settingsOverride) {
          elevation.settingsOverride = {};
        }
        elevation.settingsOverride.exteriorMaterials = newSettingsId;
        continue;
      }

      const newMtlSettingsId = uid();
      const paletteId = uid();

      const oldMtlSettings = json.tables.settings[mtlSettingsId];

      elevation.settingsOverride.exteriorMaterials = newMtlSettingsId;

      json.tables.settings[newMtlSettingsId] = {
        type: "EXTERIOR_MATERIAL_SETTINGS",
        palettes: [paletteId],
      };

      json.tables.palettes[paletteId] = {
        name: `Palette for ${elevation.prettyName}`,
        ...oldMtlSettings,
        type: "EXTERIOR_PALETTE",
      };
    }

    if (!json.electricalSystem.roomClearRules) {
      json.electricalSystem.roomClearRules = {};
    }

    return json;
  },
};

export default migration_0_0_14;
